import _ from 'underscore';

import Model from '../../model/model';
import Module from '../../core/module';
import Contract from '../../model/contract';
import ContractForm from './contracts.form';
import Contracts from '../../collection/contracts';
import TasksModule from './list';

import { roleAC, } from '../../roles';
import { restrict, } from '../../model/actions';
import { ask, } from '../../utils/popups';
import { asc, desc } from '../../collection/sort';





export default Module.extend( { 

    template: 'module/tasks/contracts.list',

    url() {
        return 'contracts/list';
    },

    open() {
        const {
            page = 1, limit = 10,
            sort = 'title', direction = 'asc',
            activeId,
            filters = {}
        } = this.state() || {};
        this.setState( { page, limit, sort, direction, activeId, filters } );

        const { contracts } = this.options;

        const actions = this.options.actions = {
            
            defaults: 'edit',

            // todo cluster admin
            create: restrict( roleAC, 
                // saved model will be inserted into 
                // this.options.contracts (which is global)
                () => this.trigger( ContractForm.OPEN, new Contract() ) ),
            
            // todo cluster admin
            edit: restrict( roleAC,
                // saved model will be merged into 
                // this.options.contracts (which is global)
                current => this.trigger( ContractForm.OPEN, current.clone() ) ),
            
            // todo cluster admin
            destroy: restrict( roleAC, current => ask( 'contract::label - confirm delete',
                'contract::label - delete', 
                'actions::yes', 'actions::no',
                () => contracts.destroy( current ) )
                    .then( () => contracts.remove( current ) )
                    .then( () => this.options.sorted.remove( current ))
                    .then( () => {
                        const { page, limit } = this.state();
                        if (contracts.length < (page - 1) * limit + 1)
                            if (contracts.length)
                                this.setState( { page: page - 1, } );
                    } )
                    .then( () => this.render() )
                    .then( () => this.navigated() ) ),
        };

        this.options.sorted = new Contracts();
        this.options.filtered = new Contracts( { actions, } );
        
        const {
            title = '',
            cluster = null,
            customer = null,
            assignedOrganization = null,
        } = this.state().filters;

        return sortFn( this.state(), this.options.contracts, this.options.sorted )
            .then( () => this.bind( new FilterModel( { 
                title, 
                cluster,
                customer,
                assignedOrganization,
            } ) ) );
    },

    start() {
        const { filtered, } = this.options;
        filtered.plugActionSource( this.Grid );

        this.listenTo( filtered, 'activate deactivate', 
            () => {
                const current = filtered.current();
                const activeId = current ? current.id : undefined;
                this.setState( { activeId, } );
                this.navigated();
            } );

        const fn = () => onFilter.call( this, this.model.toJSON() );
        this.listenTo( this.model, 'change:cluster change:customer change:assignedOrganization', 
            _.debounce( fn, 300 ) );
        this.listenTo( this.model, 'change:title', 
            _.debounce( fn, 300 ) );

        return this.Grid.focus(),
            this;
    },

    stop() {
        const { filtered } = this.options;

        filtered.unplugActionSource( this.Grid );
        this.Grid.ungrab( filtered );
        this.stopListening( filtered );

        this.stopListening( this.model );

        return this;
    },

    serialize() {
        const { clusters, organizations } = this.options;
        const { sorted, filtered, } = this.options;
        const { sort, direction, } = this.state();
        filter( this.state(), sorted, filtered );

        return {
            clusters, organizations,
            actionList: filtered.actions,
            collection: filtered,
            direction, sort,
        };
    },

    events: {

        'click .-sort'({currentTarget}) {
            const { direction, sort: sortField, } = currentTarget.dataset;
            const { contracts, sorted, } = this.options;

            return this.setState( { page: 1, direction, sort: sortField, } ),
                sortFn( this.state(), contracts, sorted, )
                    .then( () => this.render() )
                    .then( () => this.navigated() );
        },

        'click .-clear-filters'() {
            this.model.clear( { silent: true, } );
            this.model.set( { ...defaultFilters } );
        },

    },

    [Module.event( 'Paging:page')](page) {
        const { sorted, filtered } = this.options;

        return this.setState( { page: +page, } ),
            filter( this.state(), sorted, filtered ),
            Promise.all( [this.Grid.render(), this.Paging.render()] )
                .then( () => this.navigated() );
    },

    [Module.event( 'nav:map' )]() {
        this.trigger( TasksModule.OPEN_MAP, this.state().tasksFiltersState );
    },

    [Module.event( 'nav:list' )]() {
        this.trigger( TasksModule.OPEN_LIST, this.state().tasksFiltersState );
    },

} );





const defaultFilters = {
    title: '',
    cluster: null,
    customer: null,
    assignedOrganization: null,
};

const FilterModel = Model.extend( {
    computeds: {

        changed: {
            deps: ['title', 'cluster', 'customer', 'assignedOrganization'],
            get() {
                return !!this
                    .diff( new Model( defaultFilters ) )
                    .length;
            }
        }

    }
} );





function onFilter(jsonAttrs) {
    const { sorted, filtered, } = this.options;
    return this.setState( { page: 1, filters: jsonAttrs, } ),
        filter( this.state(), sorted, filtered ),
        Promise.all( [this.Grid.render(), this.Paging.render()] )
            .then( () => this.navigated() ); // todo focus
}

function sortFn({ sort: sortField, direction }, source, dest) {
    const sortById = model => +model.id;
    if (sortField === 'id')
        sortField = sortById;

    const sorting = 'asc' === direction
        ? asc( source.models, [sortField, sortById] )
        : desc( source.models, [sortField, sortById] );

    return sorting.then( sortedModels => dest.reset( sortedModels ) );
}

function filter({ page, limit, activeId, filters = {}, }, source, dest) {
    const { title = '', cluster, customer, assignedOrganization } = filters;
    const searchString = title.toLowerCase();

    const filtered = source.models
        .filter( model => ~(model.id + '').indexOf( searchString )
            || ~model.get( 'title' ).toLowerCase().indexOf( searchString ) 
            || ~(model.get( 'no' ) || '').toLowerCase().indexOf( searchString ) )
        .filter( model => !cluster 
            || model.get( 'cluster' )
            && model.get( 'cluster' ).id == cluster.id )
            .filter( model => !customer 
            || model.get( 'customer' )
            && model.get( 'customer' ).id == customer.id )
        .filter( model => !assignedOrganization 
            || model.get( 'assigned_organization') 
            && model.get( 'assigned_organization' ).id == assignedOrganization.id )

    dest.reset( filtered
        .filter( (model, index) =>
            index >= (page - 1) * limit && index < page * limit )
        .map( model => 
            new Contract( { ...model.toJSON() } ) ) );

    const activeIndex = dest.findIndex( model => +model.id === +activeId );
    if (activeIndex > -1)
        dest.activate( activeIndex );
    else
        dest.restoreActive();
        
    dest.total = filtered.length;
    dest.page = page;
    dest.limit = limit;
}


// WEBPACK FOOTER //
// ./src/js/module/tasks/contracts.list.js